<template>
  <div class="container-fluid">
    <page-header :page="page">
      <template #custom_actions>
        <action-button
          v-if="canAdd"
          text="Pedir Libro"
          variant="outline-success"
          i="fas fa-book-open"
          class="book-btn"
          @click="goToRequestSearch"
        />
      </template>
    </page-header>

    <div class="col-sm-12 col-md-8 col-lg-6 col-xl-3 bg-gray-1 py-2">
      <div class="row">
        <div class="col-sm my-1">
          <custom-drop-down
            v-model="selectedYear"
            fieldkey="id"
            fieldname="name"
            :clearable="false"
            :options="years"
            placeholder="Seleccione"
          />
        </div>
        <div class="col-sm-12 my-1 d-flex justify-content-end col-md-4">
          <action-button
            text="Buscar"
            variant="success"
            i="fas fa-search"
            @click="searchOrders"
          />
        </div>
      </div>
    </div>

    <custom-separator
      text="Libros del Estudiante"
      class="my-4 custom-separator-line"
    />

    <CustomResultNotFound
      v-if="showNotResults"
      class="mt-4 row pt-3"
      text="No se ha encontrado resultado de pedidos de libro para este periodo."
    />

    <div v-if="!showNotResults" class="search-result">
      <OrderBookResultRow
        v-for="(order, idx) in studentBookOrders"
        :key="idx"
        ref="book"
        :value="order"
      />
      <pagination
        v-if="pagination.totalItemCount > pagination.perPage"
        :data="pagination"
        @pagination-go-page="onPageChanged"
      />
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import ActionButton from 'ActionButton';
import alertMixin from '@/mixin/alert.mixin';
import CustomDropDown from 'custom-drop-down';
import CustomSeparator from 'custom-separator';
import {
  getStudentBooksOrdersYears,
  getStudentBooksOrders,
} from '@/modules/books-requests/api';
import CustomResultNotFound from 'custom-result-not-found';
import OrderBookResultRow from './components/CompOrderBookResultRow/OrderBookResultRow';
import store from '@/store/index';
import Pagination from 'pagination';

const BOOK_REQUEST_SEARCH_ROUTE_NAME = 'bookRequestSearch';

export default {
  name: 'OrderBook',
  mixins: [alertMixin],
  components: {
    PageHeader,
    ActionButton,
    CustomDropDown,
    CustomSeparator,
    CustomResultNotFound,
    OrderBookResultRow,
    Pagination,
  },
  data() {
    return {
      canAdd: true,
      years: [],
      selectedYear: null,
      studentBookOrders: [],
      filters: {
        searchText: null,
      },
      pagination: {
        perPage: 10,
        currentPage: 1,
        totalItemCount: 0,
        pageCount: 0,
        count: 0,
      },
    };
  },
  computed: {
    showNotResults() {
      return this.studentBookOrders.length == 0;
    },
    filtersHeader() {
      return [
        {
          name: 'searchText',
          component: 'CustomInput',
          placeholder: 'Escriba Grado, Materia o Título',
          icon: 'fa fa-search orange-icon',
          leftIcon: true,
          type: 'text',
        },
      ];
    },
    page() {
      return {
        icon: 'fas fa-book-open',
        title: 'Pedido de Libros',
        routes: ['Inicio', 'Libros', 'Pedidos de Libros'],
      };
    },
  },
  methods: {
    async searchOrders() {
      let studentSieId = store.getters.SelectedStudent.studentId;
      await getStudentBooksOrders(
        studentSieId,
        this.selectedYear.id,
        this.pagination.currentPage,
        this.pagination.pageSize
      ).then((res) => {
        this.studentBookOrders = res.data.data;
        this.pagination = {
          ...this.pagination,
          totalItemCount: res.data.totalItemCount,
          pageCount: res.data.pageCount,
          currentPage: res.data.currentPage,
          count: res.data.count,
        };
      });
    },
    goToRequestSearch() {
      this.$router.push({ name: BOOK_REQUEST_SEARCH_ROUTE_NAME });
    },
    async onPageChanged(currentPage) {
      this.collapseAll();
      this.pagination.currentPage = currentPage;
      await this.searchOrders();
    },
    collapseAll() {
      this.studentBookOrders.forEach((book, index) => {
        this.$refs.book[index].close();
      });
    },
  },
  async mounted() {
    await getStudentBooksOrdersYears(
      store.getters.SelectedStudent.studentId
    ).then(({ data }) => {
      this.years = data;
      this.selectedYear = this.years.find((x) => x.selected);
    });

    await this.searchOrders();
  },
};
</script>

<style scoped>
i.orange-icon.orange-icon-badge-align.fas.fa-book-open {
  font-size: 16pt;
  padding-right: 6px;
}

i.orange-icon.orange-icon-badge-align.fas.fa-book-open {
  font-size: 23px;
  padding-right: 6px;
}

@media only screen and (max-width: 375px) {
  .book-btn {
    float: right;
  }
}
</style>
